const THEME_LIGHT = {
    modal: {
        background: '#ffffff',
        text: '#333333'
    },
    header: {
        background: '#f8f8f8'
    },
    ctaAgeVerify: {
        background: '#55a245',
        text: '#ffffff'
    },
    ctaDirectContinue: {
        background: '#dfdfdf',
        text: '#333333'
    },
    ctaUnderageSkip: {
        text: '#666666'
    }
};

const THEME_DARK = {
    modal: {
        background: '#333333',
        text: '#dddddd'
    },
    header: {
        background: '#3e3e3e'
    },
    ctaAgeVerify: {
        background: '#55a245',
        text: '#ffffff'
    },
    ctaDirectContinue: {
        background: '#6b7987',
        text: '#e3e7f1'
    },
    ctaUnderageSkip: {
        text: '#dddddd'
    }
};

const getDefaultTheme = (scope) => {
    const matchMediaSupported = 'function' === typeof scope.matchMedia;

    let prefersDarkTheme = false;

    if (matchMediaSupported) {
        prefersDarkTheme = scope.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    return prefersDarkTheme ? THEME_DARK : THEME_LIGHT;
}

export {THEME_LIGHT, THEME_DARK, getDefaultTheme};
